import { Box } from "@chakra-ui/react";
import {
  VerifyYourEmailAfterReset,
  VerifyYourEmailAfterSignup,
} from "@root/pages/components";
import { getPasswordRecoverEmail } from "@root/store/selectors/entities";
import { resendEmail, resetPass } from "@root/store/thunks";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormContainer } from "./styles";
import { EmailVerification } from "@root/pages";

export const CheckEmail: React.FC = () => {
  const givenEmail: any = useSelector(getPasswordRecoverEmail);
  console.log(givenEmail)
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const onSuccess = () => {
    setLoading(false);
  };

  const isResetting: boolean = givenEmail?.redirect_url;
  const onResend = () => {
    setLoading(true);
    if (isResetting) {
      dispatch(
        resetPass({
          payload: givenEmail,
          onSuccess,
          onError: () => setLoading(false),
        })
      );
    } else {
      dispatch(
        resendEmail({
          payload: givenEmail,
          onSuccess,
          onError: () => setLoading(false),
        })
      );
    }
  };

  return (
    <Box>
      <FormContainer>
        {!isResetting ? (
          <>
            <EmailVerification />
          </>
        ) : (
          <VerifyYourEmailAfterReset
            email={givenEmail?.email}
            onResend={onResend}
            loading={loading}
          />
        )}
      </FormContainer>
    </Box>
  );
};
